import styled from '@emotion/styled';
import { BreakPoints, rem } from '@triumph/design-system';

interface TableWrapperProps {
    breakpoint?: BreakPoints;
    width?: number;
    isShowOverflow?: boolean;
    hasData?: boolean;
    maxHeight?: string;
}

export interface ResultsTableWrapperProps extends TableWrapperProps {
    isLoading?: boolean;
}

export const TableWrapper = styled.div<TableWrapperProps>`
    overflow-x: ${({ isShowOverflow, hasData, breakpoint }) => {
        if (!hasData && breakpoint == BreakPoints.Xs) {
            return 'hidden';
        }
        if (breakpoint == BreakPoints.Xs) {
            return 'scroll';
        }
        if (isShowOverflow) {
            return 'visible';
        }

        return 'auto';
    }};
    overflow-y: auto;
    position: relative;
    height: 100%;
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : '375px')};
`;

export const StyledTable = styled.table<TableWrapperProps>`
    padding: 0;
    margin: 0;
    min-height: 100%;
    border-spacing: 0;
    width: ${({ width }) => (width && width > 0 ? rem(width) : '100%')};
    thead {
        & tr {
            & th {
                border-bottom: ${({ theme }) =>
                    `thin solid ${theme.colors.greyscale.gray15}`};

                &:nth-of-type(1) {
                    left: 0px;
                }
                &:nth-of-type(2) {
                    left: ${({ breakpoint }) =>
                        breakpoint !== BreakPoints.Xs ? '50px' : null};
                }
                &:last-of-type {
                    border-radius: 0px ${rem(4)} 0px 0px;
                }
            }
        }
    }
`;

export const NoRecordsContainer = styled.div<ResultsTableWrapperProps>`
    text-align: center;
    margin-top: ${rem(48)};
    opacity: ${({ isLoading }) => (isLoading ? `.25` : null)};
    width: ${({ breakpoint }) => (breakpoint === BreakPoints.Xs ? '100%' : '')};
    position: ${({ breakpoint }) =>
        breakpoint === BreakPoints.Xs ? 'absolute' : ''};
    p {
        margin: 0;
        max-width: 100%;
    }
`;
